<template>
  <div id="app">
    <!-- <headerItem></headerItem> -->
    <div v-if="login !== null && !isQW">
      <loginItem v-if="!login"></loginItem>
      <headerItem v-else></headerItem>
    </div>
    <div v-if="login === null && !isQW && !isEle" class="loadFullScreen">
      <img src="./assets/images/loadgif.gif" alt="">
    </div>
    <div v-if="isQW">
      <!-- <candidate v-if="pathname=='/candidate'" @goto="pathname"></candidate>
      <resume v-if="pathname=='/resume'"></resume>
      <editResume v-if="pathname=='/editResume'"></editResume>
      <matching v-if="pathname=='/matching'"></matching> -->
      <home></home>
    </div>
    <div v-if="isEle">
      <ele></ele>
    </div>
  </div>
</template>

<script>
  import xz from "./common";
  const wx = window.jWeixin;
  import headerItem from "./views/headerItem";
  import loginItem from "./views/loginItem";
  import candidate from "./views/weCom/candidate.vue";
  import resume from "./views/weCom/resume.vue";
  import editResume from "./views/weCom/editResume.vue";
  import matching from "./views/weCom/matching.vue";
  import home from "./views/weCom/home.vue";
  import ele from './views/employee/ele.vue';
  export default {
    name: "app",
    components: {
      headerItem,
      loginItem,
      candidate,
      resume,
      editResume,
      matching,
      home,
      ele
    },
    data() {
      return {
        userid: "",
        entid: "",
        isQW: false,
        entry: '',
        shareTicket: '',
        corpId: '',
        userId: '',
        pathname: '',
        isEle: false
      };
    },
    computed: {
      login() {
        return this.$store.getters.getLogin;
      }
    },
    created() {
      if (window.location.pathname == '/candidate' || window.location.pathname == '/resume' || window.location.pathname == '/editResume' || window.location.pathname == '/matching') {
        this.isQW = true;
        this.pathname = window.location.pathname;
        console.log('sa', this.pathname)
        // let id = 'caa39434-539c-40cb-95d6-31b215f0f9dc';
        // Cookies.set("userid-b", id);
        // Cookies.set("entid-b", id);
      } else if (window.location.pathname == '/eleApplication' || window.location.pathname == '/bgApplication' || window.location.pathname == '/qwNotify' || window.location.pathname == '/insuranceH5'|| window.location.pathname == '/empApplication' || window.location.pathname == '/interviewApplication' || window.location.pathname == '/chat') {
        this.isEle = true;
      } else {
        this.userid = Cookies.get("userid-b");
        this.entid = Cookies.get("entid-b");
        if (this.userid && this.entid) { //如果本地有存个人id信息
          this.$store.commit("setLogin", true);
          // })
        } else {
          this.$store.commit("setLogin", false);
        }
      }
      // if(Cookies.get('userid-b')){
      //   this.signOut();
      // }
    },
    methods: {
      goto(val) {
        this.pathname = val
      },
      signOut() {
        Cookies.remove("userid-b");
        Cookies.remove("entid-b");
        Cookies.remove("token");
        this.$store.commit("setLogin", false);
        localStorage.removeItem("router");
        localStorage.removeItem('activeRoutes');
        localStorage.removeItem("activeRouter");
        localStorage.removeItem("isPartner");
        location.href = "/";
      },
    }
  };
</script>
<style>
  .el-dialog {
    border-radius: 10px !important;
  }

  .el-dialog__header {
    border-radius: 10px 10px 0 0 !important;
  }
</style>
<style scoped>
  .loadFullScreen {
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background: #fff;
    display: flex;
    align-items: center;
  }

  .loadFullScreen img {
    display: block;
    width: 40px;
    height: 40px;
    margin: 0 auto;
  }
</style>
<style>
  @import url("../src/assets/employee/css/subject.css");
  @import url("../src/assets/employee/css/form.css");
  @import url("../src/assets/employee/css/OA.css");
  @import url("../src/assets/employee/css/oth.css");

  .cp {
    cursor: pointer;
  }

  * {
    margin: 0;
    padding: 0;
  }

  input {
    margin: 0;
    padding: 0;
    outline: none;
  }

  button {
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
    cursor: pointer;
  }

  * {
    outline: none;
  }

  .el-pagination {
    padding: 10px 15px !important;
  }

  .el-pager li.active {
    color: #19bd92 !important;
    cursor: default;
  }

  .el-pager li:hover {
    color: #19bd92 !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #19bd92 !important;
    border-color: #19bd92 !important;
  }

  .el-checkbox__inner:hover,
  .el-checkbox__inner:hover {
    border-color: #19bd92 !important;
  }

  .el-breadcrumb__inner a:hover,
  .el-breadcrumb__inner.is-link:hover {
    color: #19bd92 !important;
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    color: #19bd92 !important;
  }

  .el-table th.gutter {
    display: table-cell !important;
  }

  .el-select .el-input.is-focus .el-input__inner {
    border-color: #19bd92 !important;
  }

  .el-select .el-input__inner:focus {
    border-color: #19bd92 !important;
  }

  .el-date-table td.today span {
    color: #19bd92 !important;
  }

  .el-date-table td.available:hover {
    color: #19bd92 !important;
  }

  .el-input__inner:hover {
    color: #19bd92 !important;
  }

  .el-input__inner:focus {
    border-color: #19bd92 !important;
  }

  .el-textarea__inner:focus {
    border-color: #19bd92 !important;
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    background-color: #19bd92 !important;
  }

  .el-month-table td.current:not(.disabled) .cell {
    color: #19bd92 !important;
  }

  .el-month-table td .cell:hover {
    color: #19bd92 !important;
  }

  .el-radio.is-bordered.is-checked {
    border-color: #19bd92 !important;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #19bd92 !important;
    background: #19bd92 !important;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #19bd92 !important;
  }

  .el-radio__inner:hover {
    border-color: #19bd92 !important;
  }

  .el-table-column--selection .cell {
    height: 24px;
  }

  .el-month-table td.today .cell {
    color: #19bd92 !important;
  }

  .el-table__fixed {
    /*  让固定列的高自适应，且设置!important覆盖ele-ui的默认样式 */
    height: auto !important;
    bottom: 0px;
    /* 固定列默认设置了定位*/
    position: absolute;
    top: 0;
    left: 0;
    /*只需要再设置一下bottom的值，让固定列和父元素的底部出现距离即可*/
  }

  /* 解决 el-table__fixed导致滚动条无法拖动 */
  .el-table--scrollable-x .el-table__body-wrapper {
    z-index: 2;
  }

  /* .el-table__empty-text {
display: block;
width: 500px;
height: 385px;
padding-top: 300px;
background:url("../src/assets/employee/images/nodate.jpg") no-repeat;
color: #909399;
box-sizing: border-box;
} */
  .el-table__empty-block {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    padding-right: 100%;
  }

  .el-pagination__sizes .el-input .el-input__inner:hover {
    border-color: #19bd92 !important;
  }

  .el-date-table td.current:not(.disabled) span {
    background-color: #19bf92 !important;
    color: #fff !important;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #19bf92 !important;
  }

  .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: #19bf92 !important;
  }

  .el-date-editor .el-range-separator {
    line-height: 24px !important;
  }

  .el-tabs__item.is-active {
    color: #19bd92 !important;
  }

  .el-tabs__item:hover {
    color: #19bd92 !important;
  }

  .el-tabs__active-bar {
    background-color: #19bd92 !important;
  }

  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #19bd92 !important;
    border-color: #19bd92 !important;
  }

  .el-radio-button__inner:hover {
    color: #19bd92 !important;
  }

  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #fff !important;
  }

  .el-tree-node.is-current>.el-tree-node__content {
    background: #f5f7fa;
    color: #19bd92;
    font-weight: bold;
  }

  .el-table__body tr.current-row>td.el-table__cell {
    background: #19bd92 !important;
  }

  /* .el-table__body tr.current-row > td.el-table__cell {
  background: #d2dcf8!important;
} */

  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active,
  .el-cascader-node.is-selectable.in-checked-path {
    color: #19bd92 !important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  .greenName {
    color: #19bd92;
  }

  .blueName {
    color: #598DE7;
  }

  .topForm .el-form-item {
    margin-bottom: 10px !important;
  }
  .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
  .el-tooltip__popper {
    max-width: 800px!important;
  }

</style>